import { useParams } from "react-router";
import { useRelationshipsRelationshipShowQuery } from "@/services/backend/relationships/api/service";
import { CommitmentCard } from "@/routes/customers/[customerId]/relationships/[relationshipId]/commitments/[commitmentId]/_components/commitment-card";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { ContactCardWithMutation } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";
import { NullUUID } from "@bitory-gmbh/nidavellir";
import {
  useRltWorkOrderShowQuery,
  useRltWorkOrderUpdateRepresentativeMutation,
  useRltWorkOrderUpdateServiceAddressMutation,
  useRltWorkOrderUpdateServiceContactMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";

export function DataRoute() {
  const { relationshipId, commitmentId } = useParams();
  const { data: relationship } = useRelationshipsRelationshipShowQuery({
    id: relationshipId!,
  });

  const commitment = relationship?.commitments.find(
    (c) => c.id === commitmentId,
  );

  const { data: workOrder } = useRltWorkOrderShowQuery({
    id: commitment?.documentId || NullUUID,
  });

  if (!workOrder) return null;

  return (
    <div className="grid gap-2">
      <CommitmentCard commitment={commitment!} />
      <ServiceAddressCardWithMutation
        id={workOrder!.id}
        address={workOrder!.serviceAddress}
        mutation={useRltWorkOrderUpdateServiceAddressMutation}
      />
      <div className="md:grid md:grid-cols-2 md:gap-2">
        <ContactCardWithMutation
          id={workOrder!.id}
          contact={workOrder!.serviceContact}
          mutation={useRltWorkOrderUpdateServiceContactMutation}
        />
        <RepresentativeCardWithMutation
          id={workOrder!.id}
          representative={workOrder!.representative}
          mutation={useRltWorkOrderUpdateRepresentativeMutation}
        />
      </div>
    </div>
  );
}
